import Header from "./Components/Header/Header";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LoginPage from "./Pages/LoginPage";
import User from "./Components/Profile/User";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "./store/auth-reducer";
import Home from "./Pages/Home";

function App() {
  const [displayName, setDisplayName] = useState("");
  const [photoUrl, setPhotoUrl] = useState("");
  const dispatch = useDispatch();

  const loggedIn = useSelector((state) => state.auth.isLoggedIn);
  const email = !!localStorage.getItem("email");
  // console.log(email);

  useEffect(() => {
    if (localStorage.getItem("token")) {
      if (localStorage.getItem("verify")) {
        dispatch(authActions.verify());
      }
      if (localStorage.getItem("displayName")) {
        setDisplayName(localStorage.getItem("displayName"));
        if (localStorage.getItem("photoUrl")) {
          setPhotoUrl(localStorage.getItem("photoUrl"));
          dispatch(authActions.complete());
        }
      }
    }
  }, [dispatch]);

  const profileCompleteHandler = (name, photo) => {
    setDisplayName(name);
    setPhotoUrl(photo);
  };
  return (
    <>
      <Router>
        <Header></Header>
        <Routes>
          <Route
            path="/"
            element={
              <LoginPage
                profileCompleteCheck={profileCompleteHandler}
              ></LoginPage>
            }
          />
          
          {(loggedIn || email) && (
            <Route path="/home" element={<Home></Home>} />
          )}

          {(!loggedIn || !email) && (
            <Route
              path="*"
              element={
                <LoginPage
                  profileCompleteCheck={profileCompleteHandler}
                ></LoginPage>
              }
            />
          )}

          {(loggedIn || email) && (
            <Route
              path="/user"
              element={
                <User displayName={displayName} photoUrl={photoUrl}></User>
              }
            />
          )}
        </Routes>
      </Router>
    </>
  );
}

export default App;
